
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/skigebiete",
      function () {
        return require("private-next-pages/[region]/skigebiete.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/skigebiete"])
      });
    }
  